window.onload = function() {
    waitForRudderStack(1)
}


function waitForRudderStack(attempt){
    const retryFrequency = 10
    const maxWait = 10000
    const maxAttempts = maxWait / retryFrequency
  
    if(typeof window.rudderanalytics !== "undefined"){
      const urlParams = new URLSearchParams(window.location.search);
      const personId = urlParams.get('id');
      const personLongId = urlParams.get('long_id');
      const anonymousId = urlParams.get('rs_id');

      // Anonymous id is only sent if the user is not logged in. Person id is always sent, despite being a full user (logged in) or not, at least in iOS.
      if (anonymousId) {
        window.rudderanalytics.setAnonymousId(anonymousId);
        console.log("anonymous id worked")
      } else if (personId) {
        window.rudderanalytics.identify(personId, {"person_id": personLongId});
        console.log("person id worked")
      }
    }
    else {
      attempt += 1
      if (attempt <= maxAttempts) {
         setTimeout(waitForRudderStack, 50, attempt); 
      }
    }
}